<template>
  <div class="TabPaneContent" ref="tabPaneContentRef">
    <div class="book-alert" v-if="msgAlertShow">
      <BookCourseAlert
        :show="msgAlertShow"
        :count="unBookedCourse.length"
        @onClose="doCloseBookAlert"
        @onBook="doBookCourse"
      />
    </div>
    <MathCalendar :caclDate="caclDate" @dateClick="dateClick" ref="mathCalendarRef" />
    <div v-if="!coursesLoading && periodsList.length" class="has-content">
      <CourseBar
        :initSelectedIndex="initSelectedCourseIndex"
        :list="periodsList"
        :showDate="showDate"
        @changeCourse="changePeriod"
      ></CourseBar>
      <div
        v-if="
          periodsList[initSelectedCourseIndex].periodOnline &&
          periodsList[initSelectedCourseIndex].tasks &&
          periodsList[initSelectedCourseIndex].tasks.some((t) => t.isShow)
        "
        class="task-list-main"
      >
        <div
          v-for="moduleTask in periodsList[initSelectedCourseIndex].tasks"
          :key="moduleTask.moduleId"
        >
          <!-- 预习模块 -->
          <div
            class="task-list-item mb24 br-8"
            v-if="moduleTask.isShow && moduleTask.moduleType === MODULE_TYPE.PRE_STUDY"
          >
            <div class="special-wrap">
              <h3>预习</h3>
              <YawwButton
                :type="PRE_STUDY_BUTTONS[moduleTask.status].type"
                :text="PRE_STUDY_BUTTONS[moduleTask.status].text"
              />
            </div>
          </div>
          <!-- 任务学习模块 -->
          <div
            class="task-module br-8"
            v-if="moduleTask.isShow && moduleTask.moduleType === MODULE_TYPE.TASK"
          >
            <div class="task-list-item border stu-time">
              <span>上课时段：</span>
              <span
                v-for="(obj, i) in handleTime(moduleTask.tasks)"
                :key="i"
                :class="{ 'has-join': i < handleTime(moduleTask.tasks).length - 1 }"
              >
                {{ `${obj.bookStartTime}-${obj.bookEndTime}` }}
              </span>
            </div>
            <div
              class="period-task-list-item"
              v-for="(taskItem, i) in moduleTask.tasks"
              :key="taskItem.moduleId"
            >
              <div class="content">
                <div class="l">
                  <h3>{{ taskItem.moduleName }}</h3>
                  <div class="l-status">
                    <!-- <span>{{ `进度 ${taskItem.finishTaskCnt}/${taskItem.totalTaskCnt}` }}</span> -->
                    <span>进度</span>
                    <span class="l-status-d">{{ taskItem.finishTaskCnt }}</span>
                    <span>{{ `/${taskItem.totalTaskCnt}` }}</span>
                    <span
                      class="line"
                      v-if="
                        taskItem.homework &&
                        (taskItem.homework.status === -1 || taskItem.homework.status === 0)
                      "
                    ></span>
                    <span
                      v-if="
                        taskItem.homework &&
                        (taskItem.homework.status === -1 || taskItem.homework.status === 0)
                      "
                    >
                      巩固作业待解锁
                    </span>
                  </div>
                </div>
                <div class="r">
                  <div>
                    <template v-if="taskItem.homework">
                      <el-tooltip
                        v-if="HOMEWORK_BUTTONS[taskItem.homework.status].disabled"
                        class="item"
                        effect="dark"
                        content="当前作业未解锁，请先完成知识讲授任务"
                        placement="top"
                      >
                        <YawwButton
                          v-if="taskItem.homework"
                          :type="HOMEWORK_BUTTONS[taskItem.homework.status].type"
                          :text="HOMEWORK_BUTTONS[taskItem.homework.status].text"
                          :disabled="HOMEWORK_BUTTONS[taskItem.homework.status].disabled"
                        />
                      </el-tooltip>
                      <YawwButton
                        v-else
                        :type="HOMEWORK_BUTTONS[taskItem.homework.status].type"
                        :text="HOMEWORK_BUTTONS[taskItem.homework.status].text"
                        :disabled="HOMEWORK_BUTTONS[taskItem.homework.status].disabled"
                        @click="courseClick(taskItem.homework)"
                      />
                    </template>

                    <YawwButton
                      :type="PERIOD_BUTTONS[taskItem.status].type"
                      :showLiving="PERIOD_BUTTONS[taskItem.status].showLiving"
                      :text="PERIOD_BUTTONS[taskItem.status].text"
                      :disabled="PERIOD_BUTTONS[taskItem.status].disabled"
                      @click="courseClick(taskItem)"
                    />
                  </div>
                  <div v-if="taskItem.moduleExpireDesc" class="out-date-tip">
                    {{ taskItem.moduleExpireDesc }}
                  </div>
                </div>
              </div>
              <div class="border" v-if="moduleTask.tasks.length - 1 !== i" />
            </div>
          </div>
          <!-- 个性化学习模块 -->
          <div
            class="ind-task"
            v-if="moduleTask.isShow && moduleTask.moduleType === MODULE_TYPE.PERSONAL_TASK"
          >
            <!-- <div class="info">
              <span>完成以上课程解锁个性化学习</span>
              <el-tooltip
                class="item"
                effect="dark"
                content="完成以上课程解锁个性化学习"
                placement="top"
              >
                <img src="@/assets/images/info_line@2x.png" alt="info" />
              </el-tooltip>
            </div> -->
            <div class="task-list-item mb24 mt24 br-8">
              <div class="special-wrap">
                <h3>个性化任务</h3>
                <YawwButton
                  :type="PERSONAL_BUTTONS[moduleTask.status].type"
                  :text="PERSONAL_BUTTONS[moduleTask.status].text"
                  :disabled="PERSONAL_BUTTONS[moduleTask.status].disabled"
                  @click="courseClick(moduleTask)"
                />
              </div>
            </div>
          </div>
          <!-- 专属小灶 -->
          <div
            class="special-cook br-8"
            v-if="moduleTask.isShow && moduleTask.moduleType === MODULE_TYPE.SPECIAL_COOK"
          >
            <div class="spc-desc">
              <span class="spc-desc-title">专属小灶</span>
              <span class="spc-desc-desc">
                <span>根据互动数据生成</span>
              </span>
            </div>
            <div class="task-list-item br-8">
              <div class="special-wrap">
                <h3>{{ moduleTask.moduleName }}</h3>
                <YawwButton
                  :type="SPECIAL_COOK_BUTTONS[moduleTask.status].type"
                  :text="SPECIAL_COOK_BUTTONS[moduleTask.status].text"
                  :disabled="SPECIAL_COOK_BUTTONS[moduleTask.status].disabled"
                  @click="courseClick(moduleTask)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="task-list-empty">
        <div class="wrap">
          <img src="@/assets/images/task/no-course@2x.png" width="393" height="304" alt="" />
          <div>课程准备中</div>
        </div>
      </div>
    </div>
    <div v-else-if="!coursesLoading && !periodsList.length" class="no-content">
      <div class="wrap" v-if="!hasDate">
        <img src="@/assets/images/task/no-task@2x.png" width="393" height="303" alt="" />
        <div>请联系辅导老师,预约已购课程</div>
      </div>
      <div class="wrap" v-else>
        <img src="@/assets/images/task/no-task@2x.png" width="394" height="303" alt="" />
        <div>本日暂无学习任务</div>
      </div>
    </div>
    <BookCourseDialog
      v-if="bookCourseDialogShow"
      :courses="unBookedCourse"
      :show="bookCourseDialogShow"
      @update:show="doCloseBookDialog"
      @bookSuccess="handleBookSuccess"
    />
  </div>
</template>

<script>
import CourseBar from './CourseBar';
import MathCalendar from './MathCalendar.vue';
import YawwButton, { BUTTON_TYPE } from '@/components/YawwButton';
import dayjs from 'dayjs';
import BookCourseAlert from '@/modules/stu/views/member/components/BookCourseAlert';
import BookCourseDialog from '../MyCourse/BookCourseDialog';

const TASK_STATUS = {
  NONE: -1,
  NO_START: 0,
  DOING: 1,
  DONE: 2,
  OUT_DATE: 9,
};
export default {
  customModifiers: {
    'onBook.debounce.300': 'doBookCourse', // 添加延迟时间 300ms
  },
  name: 'TabPaneContent',
  components: {
    CourseBar,
    MathCalendar,
    YawwButton,
    BookCourseAlert,
    BookCourseDialog,
  },
  props: {
    type: {
      type: Number,
      default: 0, //0 系统课（默认），1 直播课（赠送）， 2 资料课（赠送）
    },
  },
  data() {
    return {
      msgAlertShow: false,
      PRE_STUDY_BUTTONS: {
        [-1]: {
          type: BUTTON_TYPE.INFO,
          text: '未开课',
        },
        [0]: {
          type: BUTTON_TYPE.INFO,
          text: '未开课',
        },
        [1]: {
          type: BUTTON_TYPE.COMMON,
          text: '开始学习',
        },
        [2]: {
          type: BUTTON_TYPE.COMMON,
          text: '继续学习',
        },
        [3]: {
          type: BUTTON_TYPE.INFO,
          text: '重新学习',
        },
        [9]: {
          type: BUTTON_TYPE.INFO,
          text: '已过期',
        },
      },
      PERSONAL_BUTTONS: {
        [-1]: {
          type: BUTTON_TYPE.INFO,
          text: '待解锁',
          disabled: true,
        },
        [0]: {
          type: BUTTON_TYPE.INFO,
          text: '待解锁',
          disabled: true,
        },
        [1]: {
          type: BUTTON_TYPE.PRIMARY,
          text: '开始学习',
        },
        [2]: {
          type: BUTTON_TYPE.PRIMARY,
          text: '继续学习',
        },
        [3]: {
          type: BUTTON_TYPE.INFO,
          text: '已完成',
          disabled: true,
        },
        [9]: {
          type: BUTTON_TYPE.INFO,
          text: '已过期',
          disabled: true,
        },
      },
      HOMEWORK_BUTTONS: {
        [-1]: {
          type: BUTTON_TYPE.INFO,
          text: '待解锁',
          disabled: true,
        },
        [0]: {
          type: BUTTON_TYPE.INFO,
          text: '待解锁',
          disabled: true,
        },
        [1]: {
          type: BUTTON_TYPE.PRIMARY,
          text: '做作业',
        },
        [2]: {
          type: BUTTON_TYPE.PRIMARY,
          text: '继续作业',
        },
        [3]: {
          type: BUTTON_TYPE.INFO,
          text: '查看作业',
        },
        [9]: {
          type: BUTTON_TYPE.INFO,
          text: '已过期',
          disabled: true,
        },
      },
      PERIOD_BUTTONS: {
        [-1]: {
          type: BUTTON_TYPE.INFO,
          text: '未开课',
          // disabled: true,
        },
        [0]: {
          type: BUTTON_TYPE.INFO,
          text: '未开课',
          // disabled: true,
        },
        [1]: {
          type: BUTTON_TYPE.PRIMARY,
          text: '已开课',
          showLiving: true,
        },
        [2]: {
          type: BUTTON_TYPE.PRIMARY,
          text: '已开课',
          showLiving: true,
        },
        [3]: {
          type: BUTTON_TYPE.COMMON,
          text: '看回放',
        },
        [9]: {
          type: BUTTON_TYPE.INFO,
          text: '已过期',
          disabled: true,
        },
      },
      // 专属小灶
      SPECIAL_COOK_BUTTONS: {
        [-1]: {
          type: BUTTON_TYPE.INFO,
          text: '待解锁',
          disabled: true,
        },
        [0]: {
          type: BUTTON_TYPE.INFO,
          text: '待解锁',
          disabled: true,
        },
        [1]: {
          type: BUTTON_TYPE.COMMON,
          text: '开始学习',
        },
        [2]: {
          type: BUTTON_TYPE.COMMON,
          text: '继续学习',
        },
        [3]: {
          type: BUTTON_TYPE.TEXT,
          text: '已完成',
          disabled: true,
        },
        [9]: {
          type: BUTTON_TYPE.TEXT,
          text: '已过期',
          disabled: true,
        },
      },
      MODULE_TYPE: {
        PRE_STUDY: 1,
        TASK: 2,
        HOMEWORK: 3,
        PERSONAL_TASK: 4,
        //  专属小灶
        SPECIAL_COOK: 5,
      },
      coursesLoading: true,
      periodsList: [],
      initSelectedCoursePeriod: 0,
      caclDate: void 0,
      initSelectedCourseIndex: 0,
      hasDate: true,
      showDate: '',
      unBookedCourse: [],
      bookCourseDialogShow: false,
      currentDate: null,
      timer: null,
    };
  },
  async created() {
    if (this.$route.query.d) {
      this.caclDate = this.$route.query.d * 1000;
    }
    this.getAllUnBookedCourse();

    // const data = await this.$http.get('/aiclass/lesson/unSchedule/courses');
    // this.unBookedCourse = data || [];
    // if (data && data.length) {
    //   this.msgAlertShow = true;
    // }
  },
  mounted() {
    window.addEventListener('visibilitychange', this.visibilityChangeHandler);
  },
  beforeDestroy() {
    this.timer && clearTimeout(this.timer);
    this.timer = null;
    window.removeEventListener('visibilitychange', this.visibilityChangeHandler);
  },
  methods: {
    visibilityChangeHandler() {
      if (document.visibilityState === 'visible') {
        this.dateClick(this.currentDate);
      }
      if (document.visibilityState === 'hidden') {
        this.timer && clearTimeout(this.timer);
        this.timer = null;
      }
    },
    // 刷新数据
    handleBookSuccess() {
      this.$refs.mathCalendarRef.refreshCalendar();
    },
    doCloseBookDialog() {
      this.bookCourseDialogShow = false;
      this.getAllUnBookedCourse();
    },
    async doBookCourse() {
      // this.$router.push({
      //   path: '/member/study',
      //   query: {
      //     bookCourse: 1,
      //   },
      // });
      await this.getAllUnBookedCourse();
      if (this.unBookedCourse.length > 0) {
        // 如果还有待预约的课程，则弹出预约课程弹窗
        this.bookCourseDialogShow = true;
      } else {
        this.$message.success('暂无待预约的课程');
        // 关闭顶部预约课程弹窗
        this.bookAlertShow = false;
      }
    },
    async getAllUnBookedCourse() {
      const res = await this.$http.get('/backend-api/app/study/appointment/listUnAppointed');
      this.unBookedCourse = res.courses || [];
      if (res.courses.length > 0) {
        this.msgAlertShow = true;
      }
    },
    doCloseBookAlert() {
      this.msgAlertShow = false;
    },
    async courseClick(item) {
      this.$webSeeSendTrack({
        event_id: 'study_task_module_click',
        event_type: 'click',
        data: {
          courseName: item.moduleName,
          periodsId: item.periodsId,
          moduleId: item.moduleId,
          moduleType: item.moduleType,
          status: item.status,
        },
      });
      if (item.status === 3 && item.moduleType === this.MODULE_TYPE.TASK) {
        // 看回放
        const data = await this.$http.get('/aiclass/lesson/playback/info', {
          moduleId: item.moduleId,
        });
        if (data && data.playbackUrl) {
          let sourceUrl = data.playbackUrl;
          // 如果不是.mpd结尾，需要去掉所有可能的视频格式后缀
          if (sourceUrl.indexOf('.mpd') === -1) {
            sourceUrl = sourceUrl.substring(0, sourceUrl.lastIndexOf('/'));
            sourceUrl += '/next/playlist.mpd';
          }
          let desDomain = 'lc.v5live.com';
          if (process.env.BUILD_ENV === 'dev') {
            desDomain = 'lc.dev.v5live.com/ahhcvyf6pmv';
          } else if (process.env.BUILD_ENV === 'test') {
            desDomain = 'lc.test.v5live.com/ahhcvyf6pmv';
          }
          //  直播规则
          const desURL = `https://${desDomain}/?source=${encodeURIComponent(
            sourceUrl,
          )}#/embed-player`;
          window.open(desURL, '_self');
        } else {
          this.$message.error('获取回放地址失败');
        }
        return;
      }
      if (item.status <= 0 && item.moduleType === this.MODULE_TYPE.TASK) {
        // 未开课可点击
        const bookStartTime = dayjs(item.bookStartTime * 1000).format('HH:mm');
        const bookEndTime = dayjs(item.bookEndTime * 1000).format('HH:mm');
        this.$message.error(`开课时间为${bookStartTime}-${bookEndTime}，请耐心等待`);
      } else {
        // 看直播
        const data = await this.$http.post('/aiclass/class/url', {
          moduleId: item.moduleId,
          periodId: item.periodId,
        });
        if (data && data.classUrl) {
          window.open(data.classUrl, '_self');
        } else {
          this.$message.error('获取直播地址失败');
        }
      }
    },
    handleKnow() {
      this.msgAlertShow = false;
    },
    handleTime(tasks) {
      // 使用 Set 存储唯一的时间组合
      const timeSet = new Set();
      const result = [];
      tasks.forEach((task) => {
        if (task.bookStartTime && task.bookEndTime) {
          const timeKey = `${task.bookStartTime}-${task.bookEndTime}`;
          if (!timeSet.has(timeKey)) {
            timeSet.add(timeKey);
            result.push({
              bookStartTime: dayjs(task.bookStartTime * 1000).format('HH:mm'),
              bookEndTime: dayjs(task.bookEndTime * 1000).format('HH:mm'),
            });
          }
        }
      });
      return result;
    },
    changePeriod(index) {
      this.initSelectedCourseIndex = index;
    },
    hancleModules(periodsList) {
      return periodsList.map((item) => {
        item.tasks = [
          {
            moduleId: 'prestudy-0',
            moduleName: '',
            moduleType: this.MODULE_TYPE.PRE_STUDY,
            isShow: false,
            status: TASK_STATUS.NONE,
          },
          // 虚拟集合
          {
            moduleId: 'task-1',
            moduleType: this.MODULE_TYPE.TASK,
            isShow: false,
            status: TASK_STATUS.NONE,
            tasks: [],
          },
          {
            moduleId: 'personal-task-2',
            moduleName: '',
            moduleType: this.MODULE_TYPE.PERSONAL_TASK,
            isShow: false,
            status: TASK_STATUS.NONE,
          },
          {
            moduleId: 'special-cook',
            moduleName: '',
            moduleType: this.MODULE_TYPE.SPECIAL_COOK,
            isShow: false,
            status: TASK_STATUS.NONE,
          },
        ];
        item.modules = item.modules || [];
        // 临时存储作业模块
        const homeworkModules = [];

        item.modules.forEach((mod) => {
          if (mod.moduleType === this.MODULE_TYPE.HOMEWORK) {
            homeworkModules.push(mod);
            return;
          }
          if (mod.moduleType === this.MODULE_TYPE.PRE_STUDY) {
            const preTask = item.tasks.find((t) => t.moduleType === this.MODULE_TYPE.PRE_STUDY);
            Object.assign(preTask, {
              moduleId: mod.moduleId,
              moduleName: mod.moduleName,
              moduleType: mod.moduleType,
              periodId: mod.periodId,
              isShow: true,
              status: mod.status,
            });
          } else if (mod.moduleType === this.MODULE_TYPE.PERSONAL_TASK) {
            const personalTask = item.tasks.find(
              (t) => t.moduleType === this.MODULE_TYPE.PERSONAL_TASK,
            );
            Object.assign(personalTask, {
              moduleId: mod.moduleId,
              moduleName: mod.moduleName,
              moduleType: mod.moduleType,
              periodId: mod.periodId,
              isShow: true,
              status: mod.status,
            });
          } else if (mod.moduleType === this.MODULE_TYPE.SPECIAL_COOK) {
            const specialCook = item.tasks.find(
              (t) => t.moduleType === this.MODULE_TYPE.SPECIAL_COOK,
            );
            Object.assign(specialCook, {
              moduleId: mod.moduleId,
              moduleName: mod.moduleName,
              moduleType: mod.moduleType,
              periodId: mod.periodId,
              isShow: true,
              status: mod.status,
            });
          } else if (mod.moduleType === this.MODULE_TYPE.TASK) {
            // 主要课时！！
            const task = item.tasks.find((t) => t.moduleType === this.MODULE_TYPE.TASK);
            task.isShow = true;
            task.tasks.push(mod);
            // // 处理该课时对应的作业
            // const relatedHomeworks = homeworkModules.find((hw) => hw.preModuleId === mod.moduleId);
            // if (relatedHomeworks) {
            //   mod.homework = relatedHomeworks;
            // }
          }
        });

        // 处理剩余的作业（关联的课时还未处理的情况）
        const taskContainer = item.tasks.find((t) => t.moduleType === this.MODULE_TYPE.TASK);
        homeworkModules.forEach((homework) => {
          const targetTask = taskContainer.tasks.find(
            (task) => task.moduleId === homework.preModuleId,
          );
          if (targetTask && !targetTask.homeworks) {
            targetTask.homework = homework;
          }
        });

        delete item.modules;
        return item;
      });
    },
    async dateClick(date) {
      if (!date) return;
      this.timer && clearTimeout(this.timer);
      this.timer = null;
      this.currentDate = date;
      this.showDate = dayjs(date).format('M月DD日');
      this.coursesLoading = true;
      this.initSelectedCourseIndex = 0;
      // this.hasDate = true;

      const resData = await this.$http.get('/aiclass/lesson/periods', {
        date,
      });
      const data = resData || [];
      if (this.$route.query.lesson_id) {
        const lessonId = this.$route.query.lesson_id;
        // 字符串和number类型比较
        const lessonDataIndex = data.findIndex((item) => item.periodsId == lessonId);
        if (lessonDataIndex > -1) {
          this.initSelectedCourseIndex = lessonDataIndex;
        }
      }

      const handledData = this.hancleModules(data);
      this.periodsList = handledData;
      this.coursesLoading = false;
      this.timer = setTimeout(() => {
        this.dateClick(this.currentDate);
      }, 1000 * 60);
    },
  },
};
</script>

<style lang="scss" scoped>
.TabPaneContent {
  // max-height: 800px;
  // overflow: scroll;
  border-radius: 8px;
  background: white;
  padding-bottom: 16px;
  .header {
    padding-top: 16px;
    position: sticky;
    top: 0; /* 元素在滚动时距离视口顶部的距离 */
    z-index: 10;
    background: #fff;
    &::after {
      content: '';
      display: block;
      margin: 16px 32px 0;
      border-bottom: 1px solid #f5f5f5;
    }
  }
  .task-list-main {
    padding: 0 32px;
    .br-8 {
      border-radius: 8px;
    }
    .period-task-list-item {
      padding: 0 16px;
      background-color: #fafafa;
      .content {
        padding-top: 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 16px;
      }
      .l {
        h3 {
          font-size: 16px;
          line-height: 22px;
          margin-bottom: 12px;
          padding: 0;
          margin: 0;
          margin-bottom: 8px;
        }
        &-status {
          display: flex;
          font-size: 14px;
          color: #8c8b97;
          align-items: center;
          height: 28px;
          .l-status-d {
            color: #3c3a43;
            margin-left: 5px;
          }
          .line {
            width: 1px;
            height: 10px;
            background-color: #8c8b97;
            margin: 0 8px;
          }
        }
      }
      .r {
        ::v-deep .el-button + .el-button {
          margin-left: 16px;
        }
        .out-date-tip {
          color: #8c8b97;
          font-size: 14px;
          line-height: 22px;
          text-align: right;
          margin-top: 4px;
        }
      }
      //窗口太窄时按钮左对齐，以避免未拖动水平滚动条时看不到入口按钮组
      @media (max-width: 1080px) {
        .content {
          justify-content: flex-start;
          // gap: 20px;
        }
        .l {
          margin-right: 20px;
          min-width: 200px;
          max-width: 500px;
        }
      }
    }
    .task-list-item {
      padding: 16px;
      background-color: #fafafa;
    }
    .stu-time {
      font-size: 16px;
      color: #54535c;
    }
    .border {
      border-bottom: 1px solid #f1f1f1;
    }
    .has-join::after {
      content: '、';
    }
    .task-module {
      background-color: #fafafa;
      overflow: hidden;
    }
  }
  .task-list-empty {
    padding-bottom: 32px;
  }
  .mb24 {
    margin-bottom: 24px;
  }
  .mt24 {
    margin-top: 24px;
  }
  .ind-task {
    .info {
      padding: 24px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        line-height: 22px;
        color: #999;
        font-size: 14px;
      }
      img {
        width: 16px;
        height: 16px;
        margin-left: 8px;
      }
    }
  }
  .special-cook {
    border-top: 1px dashed #f1f1f1;
    padding: 24px 0 0;

    .spc-desc {
      display: flex;
      align-items: center;
      line-height: 22px;
      margin-bottom: 16px;
      &-title {
        font-size: 16px;
        font-weight: bolder;
        background: linear-gradient(270deg, #000 0%, #0090a4 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-right: 8px;
      }
      &-desc {
        padding-left: 8px;
        padding-right: 8px;
        font-size: 14px;
        border-radius: 8px 8px 8px 2px;
        background: linear-gradient(90deg, #d1fefd 0%, #e7ecff 100%);
        span {
          background: linear-gradient(90deg, #0091ff 0%, #252dff 100%);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
    }
  }
  .special-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    h3 {
      font-size: 16px;
      line-height: 22px;
      margin: 0;
      padding: 0;
    }
  }
  .no-content {
    min-height: 248px;
    padding-top: 120px;
  }
  .wrap {
    position: relative;
    width: 196px;
    margin: auto;
    // display: flex;
    align-items: center;
    > img {
      width: 100%;
      height: auto;
    }
    > div {
      position: absolute;
      bottom: 4px;
      text-align: center;
      color: #1d1b20;
      text-align: center;
      font-size: 14px;
      left: 0;
      right: 0;
    }
  }
}
.book-alert {
  padding: 16px 32px 0;
}
</style>
